import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: block;
    width: 100%;
    background-color: ${ props => props.bgColor ? props.bgColor : '#333333'};
    padding: 120px 0;
    @media(max-width: 620px) {
        padding: 50px 0 70px;
    }
`;

export const PaddingWrapper = styled(Wrapper)`
    padding-top: ${p => p.nonTopPadding ? '0' : '120px'};
    padding-bottom: ${p => p.nonBottomPadding ? '0' : '120px'};
    color: ${COLORS.black};
`;

export const Title = styled.h2`
    display: block;
    font-family: ${FONTS.regular}, Arial, Helvetica, sans-serif;
    font-size: 32px;
    color: ${p => p.textColor ? p.textColor : COLORS.white};
    margin-bottom: 50px;
    width: 100%;
    @media(max-width: 1550px) {
        font-size: 24px;
        margin-bottom: 40px;
    }
    @media(max-width: 985px) {
        margin-bottom: 30px;
    }
`;
